import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { CookieManager } from "react-cookie-manager";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TerminiCondizioni from "./pages/TerminiCondizioni";
import Disclaimer from "./pages/Disclaimer";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <CookieManager
            translations={{
              title: "Utilizziamo i Cookie",
              message: "Questo sito utilizza cookie per migliorare la tua esperienza di navigazione. Puoi scegliere di accettare tutti i cookie, rifiutarli o gestire le tue preferenze.",
              buttonText: "Accetta Tutti",
              declineButtonText: "Rifiuta",
              manageButtonText: "Gestisci Preferenze",
              privacyPolicyText: "Informativa Privacy"
            }}
            privacyPolicyUrl="/privacy-policy"
            theme="light"
            displayType="banner"
            showManageButton={true}
            enableFloatingButton={true}
            cookieKey="armando-cookie-consent-v3"
            onAccept={() => console.log("Cookie accettati")}
            onDecline={() => console.log("Cookie rifiutati")}
            onManage={(preferences) => console.log("Preferenze modificate:", preferences)}
          >
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/termini-condizioni" element={<TerminiCondizioni />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </CookieManager>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
